import React, { useState, useEffect } from 'react';
import { styled } from '../../../stitches.config';
import Slider from "react-slick";
import Box from '../Box'

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// icons 
import backgroundDestkop from '../../../assets/img/mamadu/carrefour/background-desktop.png'
import backgroundMobile from '../../../assets/img/mamadu/carrefour/background-mobile.png'
import ArrowLeft from '../../../assets/img/mamadu/carrefour/ArrowLeft.png'
import ArrowRight from '../../../assets/img/mamadu/carrefour/ArrowRight.png'

import article1 from '../../../assets/img/mamadu/carrefour/img-1.jpg';
import article2 from '../../../assets/img/mamadu/carrefour/img-2.jpg';
import article3 from '../../../assets/img/mamadu/carrefour/img-3.jpg';
import article4 from '../../../assets/img/mamadu/carrefour/img-4.jpg';
import article5 from '../../../assets/img/mamadu/carrefour/img-5.jpg';
import article6 from '../../../assets/img/mamadu/carrefour/img-6.jpg';
import article7 from '../../../assets/img/mamadu/carrefour/img-7.jpg';



function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={ArrowRight} />
        </CustomArrow>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <CustomArrow
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
        >
            <img src={ArrowLeft} />
        </CustomArrow>
    );
}

const config = {
    settings: {
        b1: {
            title: "Powiem ci, ile mnie to kosztowało",
            description: "Przez tydzień gotowałam według przepisów Katarzyny Bosackiej.",
            img: article1,
            link: "https://mamadu.pl/166447,obiad-dla-rodziny-za-mniej-niz-5-zl-za-porcje-to-mozliwe-przepisy",
        },
        b2: {
            title: "Efekt mojego eksperymentu zaskoczy niejednego",
            description: "Od dziś wydaję na obiad tylko 5 zł.",
            img: article2,
            link: "https://mamadu.pl/166798,od-dzis-wydaje-na-obiad-tylko-5-zl-efekt-mojego-eksperymentu-zaskakuje",
        },
        b3: {
            title: "Dietetyk zdradza zasady, które są kluczem do sukcesu",
            description: "Jak gotować zdrowo, szybko i tanio?",
            img: article3,
            link: "https://mamadu.pl/166528,jak-gotowac-zdrowo-szybko-i-tanio-poznaj-rady-dietetyczki",
        },
        b4: {
            title: "Na co zwracać uwagę kupując produkty na obiad, by nie wydać przy tym fortuny",
            description: "Zdrowo, czyli jak?",
            img: article4,
            link: "https://mamadu.pl/166243,na-co-zwracac-uwage-kupujac-produkty-na-obiad-by-nie-wydac-fortuny",
        },
        b5: {
            title: "Genialne przepisy!",
            description: "Szybki obiad dla rodziny do 5 zł za osobę.",
            img: article5,
            link: "https://mamadu.pl/166081,szybki-obiad-dla-rodziny-za-5-zl-za-osobe-genialne-przepisy",
        },
        b6: {
            title: "Tak wyliczysz dokładną porcję obiadu dla każdego członka rodziny",
            description: "Nie gotuj na oko i na zmarnowanie.",
            img: article6,
            link: "https://mamadu.pl/zdrowie/166024,jak-gotowac-tanio-i-zdrowo-musisz-tylko-wiedziec-ile-to-jedna-porcja",
        },
        b7: {
            title: "Oto co warto kupić w Carrefour?",
            description: "Lista zakupów na obiad.",
            img: article7,
            link: "https://mamadu.pl/166963,lista-zakupow-na-obiad-oto-co-warto-kupic-w-carrefour",
        },
    }
}

const shuffleCards = (number) => (cards) => {
    const array = Object.keys(cards).map(k => cards[k]);
    let currentIndex = array.length, randomIndex;

    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
    const obj = array.reduce((acc, curr, i) => (acc[`b${i + number}`] = curr, acc), {})

    return obj
}

const shuffleCardsAll = shuffleCards(1)

export default props => {
    const [allCards] = useState(() => shuffleCardsAll(config.settings))
    useEffect(() => {
        console.log({ allCards })
    })
    const settings = {
        infinite: true,
        dots: true,
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1370,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    arrows: true,
                    dots: true,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "45px",
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "70px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "50px",
                }
            },
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "30px",
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                    infinite: true,
                    dots: true,
                    centerPadding: "20px",
                }
            }
        ]
    };
    return (
        <Section>
            <Wrapper>
                <h1>Gotuj z nami do 5 zł za osobę.</h1>
                {window.innerWidth > 996 ?
                    <CarouselWrapper>
                        <Slider {...settings}>
                            <Box {...props}
                                id="b1"
                                type="ASpecialCarrefour"
                                settings={allCards.b1}
                            />
                            <Box {...props}
                                id="b2"
                                type="ASpecialCarrefour"
                                settings={allCards.b2}
                            />
                            <Box {...props}
                                id="b3"
                                type="ASpecialCarrefour"
                                settings={allCards.b3}
                            />
                            <Box {...props}
                                id="b4"
                                type="ASpecialCarrefour"
                                settings={allCards.b4}
                            />
                            <Box {...props}
                                id="b5"
                                type="ASpecialCarrefour"
                                settings={allCards.b5}
                            />
                            <Box {...props}
                                id="b6"
                                type="ASpecialCarrefour"
                                settings={allCards.b6}
                            />
                            <Box {...props}
                                id="b7"
                                type="ASpecialCarrefour"
                                settings={allCards.b7}
                            />
                        </Slider>
                    </CarouselWrapper>
                    :
                    <CarouselWrapper>
                        <Slider {...settings}>
                            <Box {...props}
                                id="b1"
                                type="ASpecialCarrefour"
                                settings={allCards.b1}
                            />
                            <Box {...props}
                                id="b2"
                                type="ASpecialCarrefour"
                                settings={allCards.b2}
                            />
                            <Box {...props}
                                id="b3"
                                type="ASpecialCarrefour"
                                settings={allCards.b3}
                            />
                            <Box {...props}
                                id="b4"
                                type="ASpecialCarrefour"
                                settings={allCards.b4}
                            />
                        </Slider>
                        <Slider {...settings}>
                            <Box {...props}
                                id="b5"
                                type="ASpecialCarrefour"
                                settings={allCards.b5}
                            />
                            <Box {...props}
                                id="b6"
                                type="ASpecialCarrefour"
                                settings={allCards.b6}
                            />
                            <Box {...props}
                                id="b7"
                                type="ASpecialCarrefour"
                                settings={allCards.b7}
                            />
                        </Slider>
                    </CarouselWrapper>
                }
            </Wrapper>
        </Section>
    );
}

const CustomArrow = styled("div", {
    "img": {
        width: "43px",
        height: "43px",
        margin: "auto",
        position: "absolute",
        top: "-10px",
        left: "0"
    }
});

const CarouselWrapper = styled("div", {
    marginBottom: "55px",
    overflow: "visible",
    ".slick-list": {
        marginBottom: "50px",
        "@bp4": {
            marginBottom: "0px",
            padding: "10px 0px"
        }
    },
    ".slick-slide": {
        "& > div": {
            display: "grid",
            placeItems: "center"
        }
    },
    ".slick-arrow": {
        zIndex: 10
    },
    ".slick-prev": {
        left: "410px",
        top: "382px",
        "@media only screen and (min-width: 1370px)": {
            left: "530px"
        }
    },
    ".slick-next": {
        right: "440px",
        top: "382px",
        "@media only screen and (min-width: 1370px)": {
            right: "560px"
        }
    },
    ".slick-dots": {
        bottom: "-35px",
        "li": {
            margin: "0",
            width: "18px",
            height: "9px",
            "&.slick-active": {
                button: {
                    "&:before": {
                        color: "#E3000D",
                        "@bp4": {
                            borderRadius: "10px"
                        }
                    }
                }
            },
            "button": {
                width: "9px",
                height: "9px",
                padding: "0",
                "&:before": {
                    width: "9px",
                    height: "9px",
                    fontSize: "9px",
                    lineHeight: "9px",
                    color: "white",
                    opacity: 1,
                    "@bp4": {
                        borderWidth: "0px",
                        borderRadius: "10px"
                    }
                }
            }
        }
    }
});

const Section = styled("div", {
    overflow: "hidden",
    width: "100%",
    backgroundImage: `url("${backgroundMobile}")`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    marginTop: "20px",
    marginBottom: "10px",
    paddingBottom: "1px",
    paddingTop: "130px",
    backgroundColor: "#00428e",
    "@bp4": {
        backgroundImage: `url("${backgroundDestkop}")`,
        backgroundPosition: "center top",
        backgroundSize: "cover",
        position: "relative",
        marginTop: "10px",
        paddingTop: "104px"
    }
});

const Wrapper = styled("div", {
    width: "100%",
    maxWidth: "1266px",
    margin: "0 auto",
    "@bp4": {
        maxWidth: "990px"
    },
    "@media only screen and (min-width: 1370px)": {
        maxWidth: "1266px"
    },
    "h1": {
        fontSize: "34px",
        lineHeight: "42px",
        color: "white",
        marginBottom: "297px",
        textAlign: "center",
        padding: "0 10px",
        fontFamily: '"Montserrat", sans-serif',
        "@bp4": {
            marginBottom: "20px"
        }
    }
});